import React from 'react';

const DuplicateWarningModal = ({ isOpen, onClose, duplicateGroups, type, onDelete, currentUserId, isAdmin = false }) => {
    if (!isOpen) return null;

    const getTitle = (item) => item.Title || item.BookName || 'Không có tiêu đề';
    const getAuthors = (item) => item.OriginalAuthors || item.OriginalAuthorsList || 'Chưa cập nhật tác giả';

    const getExtraInfo = (item) => {
        if (type === 'article') {
            return item.JournalName ? `Tạp chí: ${item.JournalName}` : 'Chưa có tạp chí';
        }
        if (type === 'project' || type === 'topic') {
            return item.ProjectCode || item.TopicCode || item.ProjectCode ? `Mã: ${item.ProjectCode || item.TopicCode}` : 'Chưa có mã số';
        }
        if (type === 'book') {
            return item.Publisher ? `NXB: ${item.Publisher}` : 'Chưa có nhà xuất bản';
        }
        return '---';
    };

    const getStatusStyle = (status) => {
        switch (status) {
            case 'Đã duyệt': return { backgroundColor: '#27ae60', color: '#fff' };
            case 'Đã gửi duyệt': return { backgroundColor: '#3498db', color: '#fff' };
            case 'Từ chối': return { backgroundColor: '#e74c3c', color: '#fff' };
            case 'Yêu cầu chỉnh sửa': return { backgroundColor: '#9b59b6', color: '#fff' };
            case 'Lưu nháp': return { backgroundColor: '#f39c12', color: '#fff' };
            default: return { backgroundColor: '#95a5a6', color: '#fff' };
        }
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 9999 }}>
            <div className="modal-box form-modal-box" style={{ width: '90%', maxWidth: '1100px', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, color: '#e74c3c', display: 'flex', alignItems: 'center' }}>
                        <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '10px' }}></i>
                        Cảnh báo Dữ liệu Trùng lặp
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', border: 'none', background: 'none', cursor: 'pointer' }}>&times;</button>
                </div>

                <div className="modal-body" style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
                    <div style={{ padding: '15px', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '5px', marginBottom: '20px', border: '1px solid #ffeeba', fontSize: '15px', lineHeight: '1.5' }}>
                        Hệ thống phát hiện có <strong>{duplicateGroups.length}</strong> cụm dữ liệu có thể bị trùng lặp (do import từ SCV hoặc nhập thủ công nhiều lần). <br />
                        {isAdmin ? (
                            <span>Với tư cách là <strong>Quản trị viên</strong>, bạn có quyền kiểm tra và xóa bất kỳ bản ghi trùng lặp nào trong hệ thống.</span>
                        ) : (
                            <span>Bạn chỉ có thể thực hiện thao tác <strong>Xóa</strong> đối với các bản ghi do chính tài khoản của bạn tạo ra.</span>
                        )}
                    </div>

                    {duplicateGroups.map((group, groupIdx) => (
                        <div key={groupIdx} style={{ marginBottom: '25px', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                            <div style={{ backgroundColor: '#f8fafc', padding: '12px 15px', borderBottom: '1px solid #e2e8f0', fontWeight: 'bold', color: '#334155', display: 'flex', justifyContent: 'space-between' }}>
                                <span>Cụm trùng lặp #{groupIdx + 1}</span>
                                <span style={{ fontSize: '13px', color: '#e74c3c' }}><i className="fa-solid fa-copy" style={{ marginRight: '5px' }}></i>Phát hiện {group.length} bản ghi giống nhau</span>
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table className="custom-table" style={{ width: '100%', margin: 0, border: 'none', minWidth: '900px' }}>
                                    <thead style={{ backgroundColor: '#f1f5f9' }}>
                                        <tr>
                                            <th width="5%" style={{ textAlign: 'center' }}>ID</th>
                                            <th width="30%">Tiêu đề công trình</th>
                                            <th width="20%">Tác giả khai báo</th>
                                            <th width="15%">Thông tin khác</th>
                                            <th width="10%" style={{ textAlign: 'center' }}>Trạng thái</th>
                                            <th width="12%" style={{ textAlign: 'center' }}>Người tạo</th>
                                            <th width="8%" style={{ textAlign: 'center' }}>Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {group.map((item, idx) => {
                                            const isLocked = item.Status === 'Đã duyệt';
                                            const isOwner = isAdmin || Number(item.UserId) === Number(currentUserId);

                                            return (
                                                <tr key={idx} style={{ backgroundColor: '#fff' }}>
                                                    <td style={{ textAlign: 'center', fontWeight: 'bold', color: '#64748b' }}>{item.Id}</td>
                                                    <td>
                                                        <div style={{ color: '#0056b3', fontWeight: '500', marginBottom: '5px' }}>{getTitle(item)}</div>
                                                        {item.ArticleUrl && (
                                                            <a href={item.ArticleUrl} target="_blank" rel="noreferrer" style={{ fontSize: '12px', color: '#3498db', textDecoration: 'none' }}>
                                                                <i className="fa-solid fa-link"></i> Xem liên kết
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td style={{ fontStyle: 'italic', fontSize: '13px', color: '#475569' }}>{getAuthors(item)}</td>
                                                    <td style={{ fontSize: '13px', color: '#475569' }}>{getExtraInfo(item)}</td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <span style={{
                                                            ...getStatusStyle(item.Status),
                                                            padding: '4px 8px',
                                                            borderRadius: '12px',
                                                            fontSize: '11px',
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap',
                                                            display: 'inline-block'
                                                        }}>
                                                            {item.Status || "Lưu nháp"}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: 'center', fontSize: '13px' }}>
                                                        <div style={{ fontWeight: '500', color: '#334155' }}>
                                                            {item.CreatorName || item.FullName || item.CreatorEmail || item.CreatedByEmail || item.Email || 'Người dùng'}
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {isOwner ? (
                                                            onDelete && (
                                                                <button
                                                                    onClick={() => {
                                                                        if (!isLocked) onDelete(item.Id);
                                                                    }}
                                                                    title={isLocked ? "Hồ sơ đã duyệt, không thể xóa" : "Xóa bản ghi này"}
                                                                    style={{
                                                                        backgroundColor: isLocked ? '#f8fafc' : '#fff',
                                                                        color: isLocked ? '#cbd5e1' : '#e74c3c',
                                                                        border: `1px solid ${isLocked ? '#e2e8f0' : '#e74c3c'}`,
                                                                        padding: '6px 12px',
                                                                        borderRadius: '4px',
                                                                        cursor: isLocked ? 'not-allowed' : 'pointer',
                                                                        transition: 'all 0.2s',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                    onMouseOver={(e) => { if (!isLocked) { e.currentTarget.style.backgroundColor = '#e74c3c'; e.currentTarget.style.color = '#fff'; } }}
                                                                    onMouseOut={(e) => { if (!isLocked) { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#e74c3c'; } }}
                                                                >
                                                                    <i className="fa-solid fa-trash-can"></i>
                                                                </button>
                                                            )
                                                        ) : (
                                                            <span style={{ fontSize: '12px', color: '#94a3b8', fontStyle: 'italic' }}>
                                                                Khác
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '15px 25px', display: 'flex', justifyContent: 'flex-end', backgroundColor: '#f8fafc' }}>
                    <button type="button" className="btn-cancel" onClick={onClose} style={{ margin: 0, padding: '8px 20px' }}>Đóng cửa sổ</button>
                </div>
            </div>
        </div>
    );
};

export default DuplicateWarningModal;